import { useEffect, useState } from 'react';
import { componentName } from './const';
import View from './view';
import CnCommonPrint from '@alife/cn-sc-print-base/es/base';
const Print = View;
Print.displayName = componentName;
export function usePrintInstance(props = { isMixPrint: false }) {
    const { isMixPrint } = props;
    const [printInstance, setPrintInstance] = useState(null);
    useEffect(() => {
        if (isMixPrint) {
            setPrintInstance(new CnCommonPrint({
                isNeedWetPrint: true,
                isNeedCloudPrint: true,
                isNeedPddPrint: true,
                isNeedJdPrint: true,
                isNeedBytePrint: true,
                isNeedKuaiShouPrint: true,
                isNeedVipPrint: true, // 是否启用唯品会打印
            }));
        }
        setPrintInstance(new CnCommonPrint());
    }, []);
    return printInstance;
}
export { CnCommonPrint };
export { Print };
